import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@Component({
  selector: 'slotcom-randomprize-progress-modal',
  templateUrl: './randomprize-progress.component.html',
  styleUrls: ['./randomprize-progress.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class RandomPrizeProgressModalComponent implements OnInit {
  protected readonly randomprizeProgressModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private readonly eventManager = inject(EventManager);
  public readonly logger = inject(LoggerService);
  private readonly eventsRepo = inject(EventsRepository);

  event = signal<LimitedTimeEvent | null>(null);

  ngOnInit(): void {
    const evt = this.eventsRepo.getEventById(this.randomprizeProgressModalData.properties.eventId);

    this.event.set(evt);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(
        this.randomprizeProgressModalData.id,
        ModalType.Persisted,
        this.randomprizeProgressModalData,
        null,
        true
      )
    );
  }

  openRandomprize(): void {
    this.closeModal();

    this.eventManager.openModal(
      new Modal(
        NonPersistedModalName.RandomPrizeMinigameModalComponent,
        ModalType.View,
        this.randomprizeProgressModalData
      )
    );
  }
}
